export const REVISION_TYPES = [
  'main',
  'forms',
  'group',
  'configuration',
  'career',
] as const;

export type RevisionType = (typeof REVISION_TYPES)[number];

export interface FetchOptions extends RequestInit {
  pharmacyId: string;
  // For endpoints served outside the `/${pharmacyId}` namespace (pre-auth, external hosts)
  withoutPharmacyPrefix?: boolean;
}

export interface PaginatedResponse<T> {
  currentPage: T[];
  currentPageNumber: number;
  nbPages: number;
  pageSize: number;
  totalSize: number;
  url: string;
}

export class ApiError extends Error {
  constructor(
    public message: string,
    public status: number,
    public response?: Response,
    // Parsed error body, when the backend returned JSON
    public data?: unknown
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
